<template>
    <div>
        <div :class="{'m-t-25-b-5-desktop form-group':true}">
            <div class="col-md-6 p-5-0">
                <label class="label-form inputs-header-font">
                    {{ service.meta.workersNameSingular }}
                    <a v-if="!isContractor" href="javascript:;" @click="showContractorInfo">
                        <i class="fa fa-info-circle fa-lg"></i>
                    </a>

                    <span   :class="`status-div ${fieldworkerVisitStatus['divClass']} `"
                            v-if=" service.meta.canAssignContractorToBooking &&  itemType != 'estimate'  &&  itemType != 'inquiry'  && service.itemId">
                        <a :style="fieldworkerVisitStatus['style']" href="#" data-toggle="modal" data-target="#popupi"   :id="`acceptance_${visit.id}`"
                           @click="accept_or_rejectAdminServices(  'Appointment' , visit.booking_id ,visit.visit_status )" >
                                 <span class="color-text status-label-font">  {{ fieldworkerVisitStatus['title_confirmation'] }} </span>
                                 <img  height="12" width="12" src=" " alt="logo" class="img-responsive nav-company-logo hidden ">
                         </a>
                    </span>
                    <span    v-if="visit.contractorInfo && itemType != 'estimate'  " >
                    <confirm-attendance-button  v-if="  service.viewPage &&   fieldworkerVisitStatus && fieldworkerVisitStatus.visit_confirmed=='Confirmed'"
                                                :title ="`${visit.fieldworkerVisitStatus.visit_confirmed}`"
                                                class-div= " color-text status-label-font confirm-color"
                                                 :element-id="`custom_object_${visit.booking_id}`"
                                                 :visits-existed="service.visits"
                                                :booking-id='`${visit.booking_id}`'
                                                :optional-visit-id='`${visit.multiple_day_id}`'
                                                :info-for-confirmation='getInfoForConfirmation( `${visit.contractor_id}` ,`${visit.contractorInfo.username}`)'
                    >
                    </confirm-attendance-button>
                    <confirm-attendance-button v-if="  service.viewPage &&   fieldworkerVisitStatus && fieldworkerVisitStatus.visit_confirmed !='Confirmed'"
                                               :title ="`${fieldworkerVisitStatus.visit_confirmed}`"
                                               class-div= " color-text status-label-font unconfirm-color"
                                                :element-id="`custom_object_${visit.booking_id}`"
                                               :visits-existed="service.visits"
                                               :booking-id='`${visit.booking_id}`'
                                               :optional-visit-id='`${visit.multiple_day_id}`'
                                               :info-for-confirmation='getInfoForConfirmation( `${visit.contractor_id}` ,`${visit.contractorInfo.username}`)'
                    >
                    </confirm-attendance-button>

                    </span>
                </label>
            </div>
        </div>

        <div class="form-group fieldworker-box">
            <div :class="{'col-lg-7':!service.viewPage, 'col-lg-6':service.viewPage, 'col-md-12 fieldworker-input-design':true }" :id="`fieldworkerDiv_${signature}`">
                <div v-if="service.meta.canAssignContractorToBooking">
                    <select ref="contractor"
                            id="contractors-options-selected-field-worker"
                            :class="`required dropdown form-control contractors-options`"
                            :data-service-id="service.service_id"
                            :data-clone="service.clone"
                            :name="`contractor_${signatureArray}`"
                            >
                    </select>
                  <div class="apply_all_container_fieldworker col-md-12 p-top-6" v-show="copyToOtherAppointments" style="top:20px">
                    <a class="apply_all apply_all_not_specified" @click="applyToAll">Copy to other appointments</a></div>
                </div>
                <div v-else-if="(!service.meta.canAssignContractorToBooking && !service.itemId) || isCustomer">
                    <span>{{ service.meta.loggedUser.username | ucwords }} </span>
                    <span
                        v-if="service.meta.loggedUser.business_name"> {{
                            service.meta.loggedUser.business_name | ucwords
                        }}</span>
                    <input type="hidden"
                           :value="service.meta.loggedUser.user_id"
                           :name="`contractor_${signatureArray}`">

                </div>
                <div v-else-if="(!service.meta.canAssignContractorToBooking && service.itemId) || isCustomer">
                    <span   v-if="visit.contractorInfo.username" >{{ visit.contractorInfo.username  }} </span>
                    <span
                        v-if="visit.contractorInfo.business_name"> {{
                            visit.contractorInfo.business_name | ucwords
                        }}</span>
                    <input type="hidden"
                           :value="visit.contractorInfo.user_id"
                           :name="`contractor_${signatureArray}`">

                </div>


            </div>
            <div :class="{'col-lg-2':!service.viewPage, 'col-lg-3':service.viewPage , 'col-md-6 p-left-6-medium-screens p-relative-top-30 p-0-8-mobile':true}">
                <a class="btn ipad-fieldworker-btns-alignment btn-new-design-for-appointment fieldworker-btns-width mobile-m-top-20"
                   href="#" data-toggle="modal" data-target="#fn_nearest"
                   @click="handleNearestBooking">Nearby jobs</a>
            </div>
            <div :class="{'col-lg-2':!service.viewPage, 'col-lg-3':service.viewPage , 'col-md-6 p-relative-top-30 p-0-8-mobile':true}">
                <a class="btn btn-new-design-for-appointment fieldworker-btns-width"
                   href="#" data-toggle="modal" data-target="#fn_nearest"
                   @click="handleFindAvailbility">Availability</a>
            </div>
        </div>

        <div :class="{'col-md-12 p-0':true, 'm-top-10':service.viewPage}">
        <a v-if=" service.meta.canAssignContractorToBooking &&  itemType != 'estimate'   && service.itemId  && new Date(this.visit.startDate) > new Date()"  @click="Send_Reminder_to_Fieldworker($event)" class="btn reminder-booking-btn p-left-4"
           :visit_contractor_id="`${this.visit.contractor_id}`"  title="Send reminder">
            <i style="margin-top: 5px;" class="fa fa-repeat"></i> Send reminder

        </a>
        <!--      this.service.meta.booking.assignment_role_id  == 5 ????  5 is  "Automatic assignment"  -->

        <a   v-if=" itemType != 'estimate'  && service.itemId   &&
               ( service.meta.booking && service?.meta?.booking?.assignment_role_id && service.meta.booking.assignment_role_id  == 5)
              &&   (   service?.meta?.loggedUser?.role_id  !=   service.meta.contractorRoleId)
               && (this.visit.is_general_fieldworker ==  1)"

             class=" btn send-job-request Send_job_request_a" onclick="window.SendFieldworkerJobRequest(this)">
            <i class="fa fa-repeat Send_job_request_i"></i> Send job request
        </a>
          <i v-if="hasDate && visit.visit_status=='accepted'" :ref="`toggleIcon`"
             class="fa fa-chevron-down rotate rotate-180 float-right cursor-pointer"
             style="color: #2E4051;font-size: 18px;"
             @click.stop="toggleCollapse"></i>
    </div>
      <booking-view-contractor-tracking-map v-if="hasDate && visit.visit_status=='accepted'"
                                            v-model="visit.fieldworkerVisitStatus"
                                            :visit="visit" from-page="fieldworker"
                                            :is-running-late="visit.is_running_late == 1"
                                            :class="{'collapsed': trackingIsCollapsed}"
                                            :is-virtual=isVirtual>
      </booking-view-contractor-tracking-map>

        <div class="preloader11" style=" display:none; ">
            <img src="/pic/ajax-loader.gif" alt="Loading..."/>
        </div>

    </div>
</template>

<script>

import {getContractors, sendReminderBookings} from "@/modules/Services/api/appointments"
 import {EventBus} from "@/events/event-bus";
import {bookingEditFieldworker} from '@/modules/common/api'

export default {
    name: "AppointmentFieldWorker",
    props: {
        visit: {
            type: Object,
            required: true
        },
        service: {
            type: Object,
            required: true
        },
        itemId: {},
        duplicate: {
          default() {
            return false
          }
        },
        itemType: {},
         index: {
            type: Number,
            default() {
                return 0;
            }
        },
        hasDate: {
          type: Boolean
        }
    },
    computed: {

        fieldworkerVisitStatus() {

            // canAcceptAdminServicesCredential = CheckAuth::checkCredential(['canAcceptAdminServices']);
            // hasAcceptOrRejectServicesCredential = CheckAuth::checkCredential(['acceptOrRejectServices']);
            //    let hasCredentials = $canAcceptAdminServicesCredential || $hasAcceptOrRejectServicesCredential ? true : false;
            let title_confirmation ;
            let visit_confirmed ;
            let routeName
            let title
            let img
            let divClass
            let visit_confirmed_divClass
            let style;
            if (this.visit.visit_status ==="accepted")  {
                 divClass = 'confirm-color';
                title_confirmation= 'Accepted';
                routeName = 'rejectServices';
                title = 'Decline Appointment';
                img = '/pic/white_accepted.png';
                style = '';
            }
            else if ( this.visit.visit_status === 'declined') {
                divClass = 'unconfirm-color';
                title_confirmation = 'Declined';
                 routeName = 'acceptServices';
                title = 'Accept Appointment';
                img = '/pic/white_rejected.png';
                style = '';

            } else {

                divClass = 'unconfirm-color';
                title_confirmation = 'Pending';
                routeName = 'acceptServices';
                title = 'Accept Appointment';
                img = '/pic/white_unknown.png';
                style = '';
            }

            if (this.visit.visit_confirmed){
                visit_confirmed= 'Confirmed';
                visit_confirmed_divClass= 'confirm-color';
            }else {
                visit_confirmed= 'Unconfirmed';
                visit_confirmed_divClass= 'unconfirm-color';
            }
            return {
                title_confirmation,
                visit_confirmed,
                visit_confirmed_divClass,
                divClass,
                routeName,
                img,
                title,
                style
            }
        },

        isContractor() {
            return this.service.meta.loggedUser.role_name === 'contractor'
        },
        isCustomer() {
            return this.service.meta.loggedUser.role_name === 'customer'
        },
        signature() {
            return `${this.index}_${this.service.service_id}_${this.service.clone}`
        },
        signatureArray() {
            if (this.visit.id && this.duplicate == false){
                return `${this.visit.multiple_day_id}`
            }
            return `${this.service.service_id}_${this.service.clone}[${this.index}]`
        },
      isVirtual(){
        let businessType = $('#business_address').val();
        return businessType=='virtual'?true:false
      }
    },
    watch: {
        fieldworkerVisitStatus: {
            handler(newVal,oldVal ) {

                 this.visit.fieldworkerVisitStatus = newVal;
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            fieldworker: null,
            options: {
              data: [],
              escapeMarkup: function (markup) {
                return markup;
              }, // let our custom formatter work
              templateResult: this.templateResult,
              templateSelection: this.templateSelection,
              placeholder: 'Select one'
            },
          copyToOtherAppointments: false,
          trackingIsCollapsed: true
        }
    },
    methods: {
        getInfoForConfirmation( contractor_id ,contractorInfo_name) {
            return {
                item_type: "Technician",
                id:parseInt(contractor_id) ,  // Assuming `visit` is part of your data
                name: contractorInfo_name,
                item_id: this.visit.booking_id
            };
        },
        Send_Reminder_to_Fieldworker() {

    // Send Reminder to Fieldworker
            var element = event.currentTarget
             var id_element_vue_contractor_id = element.getAttribute('visit_contractor_id');
             $('.preloader11').show();
            id_element_vue_contractor_id=  {contractor_id: id_element_vue_contractor_id  , booking_ids: [ this.visit.booking_id] };
            sendReminderBookings(id_element_vue_contractor_id)
                    .then((response => {
                        alert(response.data.msg);
                        $('.preloader11').hide();

                    }))

},
        accept_or_rejectAdminServices(popUpLabel,book,type) {


            let base_url="";
            if (type =='accepted'){
                base_url = `/dashboard/rejectAdminServices`;
            }else  {
                base_url = `/dashboard/acceptAdminServices`;
            }
            let url = `${base_url}/${book}?vue=1`;
            window.popupi(popUpLabel, url);

        },

        handleNearestBooking() {
            // Call your logic here.
            // If you had parameters in your original function, you can pass them here.
            // For the sake of the example, I'm assuming 'Nearby bookings' and 'this'.
            window.NearestBooking2('Nearby bookings', this);
        },
        showContractorInfo() {
            popupi_alert('Info',`<p><strong>Why don&#39;t all&nbsp;${this.service.meta.workersNamePlural}<span style="color: #ff0000;">&nbsp;</span>show up in this list?<br/></strong><br/>Only active&nbsp;<?php echo $workersName; ?>&nbsp;who match the selected service and custom fields for this job will appear in the list. This helps you expand your team and offer different services in different locations while keeping job dispatching simple and minimizing the chance of assigning the wrong&nbsp;<?php echo $labelworkersName; ?>&nbsp;to the job.</p><div>If a booking is made for a mobile location, the system displays <?php echo $labelworkersName; ?> who are available within the default radius set in your job assignment settings. This ensures that you can quickly find nearby <?php echo $labelworkersName; ?> who can handle the job at the customer&#39;s location, such as their home or workplace.</div><div>&nbsp;</div><div>If the <?php echo $labelworkersName; ?> you&#39;re looking for isn't showing in this list, follow these steps:<div><ul><li>- Go to their profile and make sure it's active.</li><li>- Check their Services Provided on the Job Settings tab to ensure that they have the service you need to be added.</li><li>- If the service is added to the <?php echo $labelworkersName; ?>'s services list, click the "Edit custom field values" button to ensure that all custom fields selected for this service are enabled for this <?php echo $labelworkersName; ?>.</li><li>- Verify that the <?php echo $labelworkersName; ?>'s address in their profile is accurate and appears on Google Maps with the correct GPS coordinates.</li></ul></div><div><div><div>&nbsp;</div>For more information you can refer to this&nbsp;<a href="https://help.octopuspro.com/add-remove-services-fieldworker-profile" target="_blank" rel="noopener" data-saferedirecturl="https://help.octopuspro.com/add-remove-services-fieldworker-profile">article</a>.</div><div><br/><strong>How do I assign multiple <?php echo $workersName; ?> to the same booking?<br/></strong><br/></div><div>To assign multiple <?php echo $workersName; ?> to the same booking in OctopusPro, you can follow these steps:<div><div>Adding Appointments:<ol><li>For the service you want to add <?php echo $workersName; ?> to, click the "Add appointment" button.</li><li>Select a fieldworker for the new appointment.</li><li>Repeat steps 1 and 2 for each additional fieldworker you want to add to the same service.</li></ol></div><div>Adding Services:<ol><li>If you need to assign different <?php echo $workersName; ?> to different services, add additional services to the booking.</li><li>Assign a <?php echo $labelworkersName; ?> to each service as required. You can add a different service to the booking by pressing the "Add Service" button.</li></ol></div><div>Viewing Assigned Services and Appointments:<ol><li>Each assigned <?php echo $labelworkersName; ?> can only view their assigned services and appointments.</li><li>When multiple <?php echo $workersName; ?> are assigned to the same service, each <?php echo $labelworkersName; ?> will be able to view their appointments only. This ensures that each <?php echo $labelworkersName; ?> knows exactly what is required from them for each booking, and when it is required.</li></ol></div><div>Calculating Payments to Fieldworkers:<ol><li>OctopusPro automatically calculates <?php echo $labelworkersName; ?> payment amounts based on the services performed.</li><li>When multiple <?php echo $workersName; ?> are assigned to one service, the service total amount will be split evenly between them before calculating each <?php echo $labelworkersName; ?>'s payment amount based on their payment settings. You can always overwrite each <?php echo $labelworkersName; ?>'s payment amount manually from the invoice view page and from the <?php echo $labelworkersName; ?> booking reports while paying your fieldworkers.</li></ol></div><div>For more detailed information on how to assign multiple <?php echo $workersName; ?> to the same booking, you can refer to this<a href="https://help.octopuspro.com/assign-multiple-fieldworkers-to-a-booking" target="_blank">article.</a></div></div></div></div>`);
            $('.modal-footer').hide();
            },
      changeFieldworker(){
        let input = $(this.$refs.contractor);
        let countFieldworker = $(".ibox-content").find(".contractors-options").length;
        if(countFieldworker>1&&input.val()!=""){
          this.copyToOtherAppointments = true
        }
      },
      applyToAll(event){
          let mybtn =$(event.target);
          let message = this.applyFieldworkerChanges(mybtn);
          confirm_popup({
                title: 'Apply to fieldworkers',
                message: message,
                confirm: 'Ok',
                alert: 'true'
              }
          );
      },
      applyFieldworkerChanges(input){
        var parent1 = input.closest(".ibox-content");
        var fieldworkerVal = parent1.find(".contractors-options").val();
        var fieldworkerText = parent1.find(".contractors-options option:selected").text();
        var subFieldworkerVal = parent1.find("select.contractor_sub").val();
        var message = "Applied Successfully";
        var notAppliedContractors = [];
        $(".contractors-options").each(function(){
          var thisDropDown = $(this);
          if($("option[value='"+fieldworkerVal+"']",this).length>0){
            $(this).val(fieldworkerVal).trigger("change");
          }else{
            notAppliedContractors.push($("option:selected",this).text());
          }
        });
        if(notAppliedContractors.length>0){
          message = "This fieldworker "+fieldworkerText+" doesn't provide all services selected so the changes didn't get applied to all services?";
        }
        return message;
      },
        templateResult(repo) {
            if (repo.loading) return repo.text;
            let markup = ''
            markup = `<div class="option selected active" data-selectable="" data-value="" role="option" aria-selected="true">
                                      ${repo.img ? repo.img : ''}
                                      <span class="float-start">${repo.text}</span>
                                  </div>`
            return markup;
        },


        templateSelection(repo) {


            let markup = ''
            let img = repo.img
            markup = `<div class=" option selected active" data-selectable="" data-value="" role="option"  aria-selected="true">
                                      ${img ? img : ''}
                                      <span class="float-start">${repo.text}</span>
                                  </div>`;
          this.visit.contractor_img = img
          this.visit.contractor_text = repo.text;
          this.visit.oldContractorName = repo.contractorName
            return markup;
        },
        select2Initiator: function () {
            let vm = this
            if(this.visit.contractor_id)
              this.options.data = [{id: this.visit.contractor_id,img: this.visit.contractor_img,text: this.visit.contractor_text,contractorName:this.visit.username}]
            $(this.$refs.contractor).select2(this.options)
            setTimeout(() => {
                // Add a class to the select2-dropdown element when it is opened
                $(this.$refs.contractor).on('select2:open', function (e) {
                    var $dropdown = $('.select2-dropdown.select2-dropdown--below');

                    // Check if the dropdown exists and add your class
                    if ($dropdown.length > 0) {
                        $dropdown.addClass('top-16');
                    }
                });
            }, 1000);




            // Attach a change event listener using Select2's event
            $(this.$refs.contractor).on('change', (event) => {
                let selectedValue =  $(this.$refs.contractor).val();
                let contractor_id_tmp = this.visit.contractor_id

                this.visit.contractor_id = selectedValue;
                this.visit.oldContractorId = selectedValue;
                // EventBus.$emit('sendOldContractorId', this.visit.oldContractorId);

                // this.visit.oldContractorName = selectedValue;
                this.changeFieldworker();
                this.emitSelectValue(selectedValue);
                if(this.service.viewPage && (contractor_id_tmp != selectedValue)){//Only when change the fieldworker
                  bookingEditFieldworker(this.visit.booking_id,this.visit.id, selectedValue) .then((response) => {
                      EventBus.$emit('getFieldworkersEarningsData');
                    $.notify(response.data.message, response.data.type);
                  })
                  .catch((error) => {
                    // Handle any errors here
                  });
                }
                if(contractor_id_tmp==""||contractor_id_tmp)//For not running validation at first creation
                  this.$emit('input',selectedValue)
            });

            this.$nextTick(()=>{
              $(this.$refs.contractor).trigger('change');//trigger change for subworker
            })

            $(this.$refs.contractor).one('select2:open', function(e) {
              vm.getContractorsData(true)
            })
        },
        emitSelectValue(selectedValue) {
            EventBus.$emit('selectContractorChange', selectedValue,this.service.service_id,this.service.clone,this.index); // Emit the event with the selected value
        },
        getContractorsData(openSelect=false){
            if (!localStorage.getItem('preventChangeFieldworker') || localStorage.getItem('preventChangeFieldworker')!=='1'){
                $(this.$refs.contractor).empty()
                let loadingOption = new Option('Searching ', 'searching', false, false);
                loadingOption.setAttribute('disabled', 'disabled');
                $(this.$refs.contractor).prepend(loadingOption)
            }

            let businessType = $('#business_address').val();
            if (businessType !== 'mobile' && businessType !== 'virtual') {
              businessType = 'fixed';
            }

            let data = {
              service_id: this.service.service_id,
              clone: this.service.clone,
              selectedFieldworkerId: this.visit.contractorId,
                lat: document.getElementById('lat_1')?.value,
                lon: document.getElementById('lon_1')?.value,
                state: document.getElementById('state_1')?.value,
                postcode: document.getElementById('postcode_1')?.value,
                suburb: document.getElementById('suburb_1')?.value,
                unit_lot_number: document.getElementById('unit_lot_number_1')?.value,
                street_address: document.getElementById('street_address_1')?.value,
                street_number: document.getElementById('street_number_1')?.value,
              work_type: businessType,
              getContractors: 1,
              business_address: $("input[name='business_address']").val()
            }
            let serviceContainer = "#service_checked_" + this.service.service_id

            if (this.service.clone)
              serviceContainer += "_" + this.service.clone

            $(serviceContainer).find("[name^='attribute_']").each(function () {
              data[$(this).attr("name")] = $(this).val()
            })
            getContractors(data)
                .then((response => {
                    this.options.data = response.data.contractors_dropdown.results
                    $(this.$refs.contractor).find("option[value='searching']").remove()
                    if (!this.visit.contractor_id) {
                        $(this.$refs.contractor).prepend(new Option())
                    }
                        if (this.visit.defaultFieldworkerId) {
                            this.visit.contractor_id = this.visit.defaultFieldworkerId;
                            this.visit.defaultFieldworkerId = null;
                        }//prevent fieldworker change when Contractor location changed from view booking
if (!localStorage.getItem('preventChangeFieldworker') || localStorage.getItem('preventChangeFieldworker')!=='1'){
    // Initialize the Select2 with the data returned from the AJAX.
    $(this.$refs.contractor).select2(this.options).val(this.visit.contractor_id).trigger('change');
}else {
    localStorage.removeItem('preventChangeFieldworker');
}
                      this.autoSelectContractor();
                    if(openSelect){
                      if (this.itemType != 'estimate'){
                        $(this.$refs.contractor).select2('open')
                      }
                        // Add a class to the select2-dropdown element when it is opened
                        // var $dropdown = $('.select2-dropdown.select2-dropdown--below');
                        // // Check if the dropdown exists and add your class
                        // if ($dropdown.length > 0) {
                        //   $dropdown.addClass('top-16');
                        // }
                    }else{
                            let isOldContractorIdPresent = false;
// Loop through the contractors array
                            this.options.data.forEach(contractor => {
                                if (this.visit.oldContractorId && contractor.id ==this.visit.oldContractorId) {
                                    // Match found
                                    isOldContractorIdPresent = true;
                                }
                            });
                            if (!isOldContractorIdPresent) {
                                this.visit.fieldworkerChanged = true;
                            }
                    }


                })
                )
        },
        handleFindAvailbility() {
            // if (this.service.itemId){
            //   // let urlHandle = this.service.meta.find_availability_url.replace('findAvailability,', 'findAvailability?');
            //   // window.fn_popupi_with_parm('Find Availability', urlHandle);
            //   const optionValues = $(this.$refs.contractor)
            //       .find('option')
            //       .map(function () {
            //         return $(this).val();
            //       }).get();
            //   window.find_availability2('Find Availability',this, optionValues.slice(1));
            //
            // }else{

          let data = {
            service_id: this.service.service_id,
            lat: document.getElementById('lat_1')?.value,
            lon: document.getElementById('lon_1')?.value,
            state: document.getElementById('state_1')?.value,
            postcode: document.getElementById('postcode_1')?.value,
            suburb: document.getElementById('suburb_1')?.value,
            unit_lot_number: document.getElementById('unit_lot_number_1')?.value,
            street_address: document.getElementById('street_address_1')?.value,
            street_number: document.getElementById('street_number_1')?.value
          }

          let serviceContainer = "#service_checked_" + this.service.service_id
          if (this.service.clone!="0")
            serviceContainer += "_" + this.service.clone
          $(serviceContainer).find("[name^='attribute_']").each(function () {
            data[$(this).attr("name")] = $(this).val()
          })
              const optionValues = $(this.$refs.contractor)
                  .find('option')
                  .map(function () {
                    return $(this).val();
                  }).get();
              window.find_availability2('Find Availability',this, optionValues.slice(1),data);
            // }
        },
        addEventListeners(){
            EventBus.$on('getAvailableFieldWorkersRequest',(serviceId,clone)=>{

                if (this.service.service_id == serviceId && this.service.clone == clone){
                  this.getContractorsData();
                }

            })
            // EventBus.$on('bookingAddressesChanged', (bookingAddresses) => {
            //     this.getContractorsData() ;
            // })
            EventBus.$on('visitStatusChanged',(visit)=>{
                 if (this.visit.id == visit.id){
                    this.visit.visit_status = visit.type;
                     let divClass;
                     let title_confirmation;
                      if (visit.type ==="accepted")  {
                         divClass = 'confirm-color';
                         title_confirmation= 'Accepted';
                         this.visit.accepted_at = visit.accepted_at
                     }
                     else if ( visit.type === 'declined') {
                         divClass = 'unconfirm-color';
                         title_confirmation = 'Declined';
                     } else {
                         divClass = 'unconfirm-color';
                         title_confirmation = 'Pending';
                     }
                     this.visit.fieldworkerVisitStatus.title_confirmation = title_confirmation;
                     this.visit.fieldworkerVisitStatus.divClass =  divClass;
                 }
            })
            EventBus.$on('onTodayProcessLoaded', (todayProcessName,todayProcessClass,visit_id) => {
              this.$forceUpdate();
            });
          EventBus.$on('triggerAcceptOrRejectService',(popUpLabel,book,type) => {
            this.accept_or_rejectAdminServices(popUpLabel,book,type);
          });
        },

        autoSelectContractor() {
            const contractorId = this.getContractorIdForAutoSelect();
            // Check if the contractor ID is valid
            if (contractorId) {
                // Set the value of the select2 element
                $(this.$refs.contractor).val(contractorId).trigger('change');
                $(this.$refs.contractor).select2('close');
            }

        },

        getContractorIdForAutoSelect() {
            // Your logic to determine the contractor's ID
            // For example, based on some condition or property
            if (this.itemType === 'estimate' && this.itemId == null) {
                const firstEnabledObject = this.options.data.find(obj => obj.is_general === 1);
               return firstEnabledObject.id; // Replace with the actual ID
             }
            else if (this.visit.oldContractorId){
                return this.visit.oldContractorId;
            }
            return null;
        },
        openSelect2InNewQuote() {
            //
           // this function to open select2 in case of new quote to get contractors and auto select general
            if ((this.itemType === 'estimate' && this.itemId == null)) {
                $(this.$refs.contractor).select2('open');
            }
        },
      toggleCollapse() {
        this.trackingIsCollapsed = !this.trackingIsCollapsed
        $(this.$refs['toggleIcon']).toggleClass('rotate-180')
        this.$forceUpdate()
      },
    },
    mounted() {
        this.select2Initiator()
        this.addEventListeners();
        // Auto-select general contractor after initialization in the new quote
        this.openSelect2InNewQuote();
    }
}
</script>

<style scoped>

.preloader11 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.p-5-0 {
    padding: 0 0 0 5px;
}
.m-t-25-b-5-desktop {
    margin: 25px -15px 5px -15px;
}
.m-t-40-b-5-desktop {
    margin: 40px -15px 5px -15px;
}
.status-div a{
    text-decoration: none!important;
}
.confirm-color{
    background-color: #37BD5D !important;
    color:#FFFFFF!important;
    border-radius: 100px!important;
    padding: 4px 12px 6px 12px!important;
    width: auto!important;
}
.color-text{
    color:#FFFFFF;
}
.unconfirm-color{
    background-color: #FF932F!important;
    color:#FFFFFF!important;
    border-radius: 100px!important;
    padding: 4px 12px 6px 12px!important;
    width: auto!important;

}
.status-label-font {
    font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px;
}
.p-0 {
    padding: 0;
}
.p-relative-top-30-btns {
    position: relative;
    top: 30px;
}
.status-div{
  color:#FFFFFF!important;
  border-radius: 100px!important;
  padding: 2px 12px 6px 12px!important;
  width: auto!important;
}
.collapsed {
  display: none;
}
.rotate {
  -moz-transition: all 0.5s linear;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
  padding-right: 5px;
}

.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
  display: inline-block;
  margin-bottom: 20px;
}
/*For Laptop*/
@media (min-width: 1024px) and (max-width: 1439px) {
    .p-left-6-medium-screens {
        padding-left: 6px;
    }
}

@media (max-width: 768px) {
    .p-0-8-mobile {
        padding: 0 8px;
    }
}
</style>